import uniqWith from 'lodash/uniqWith';
/**
 * 适用于变更详情接口返回segInfoList字段
 */
export default function getNewOldFlights(flights) {
    if (flights === void 0) {
        flights = [];
    }
    return {
        oldFlights: 
        // .map(function (flight) {
        //   return Object.keys(flight).reduce(function (obj, key) {
        //     key = key.replace('old', '').replace(key[0], key[0].toLowerCase());
        //     obj[key] = flight[key] || '';
        //     return obj;
        //   }, {});
        // })
        uniqWith(flights.filter(function (flight) {
            return flight.oldFlightDate;
        }), function (a, b) {
            return (a.oldFlightDate + "-" + a.oldDepTime + "-" + a.oldFlightNo + "-" + a.olddepAirport + "-" + a.oldarrAirport ===
                b.oldFlightDate + "-" + b.oldDepTime + "-" + b.oldFlightNo + "-" + b.olddepAirport + "-" + b.oldarrAirport);
        }),
        newFlights: uniqWith(flights, function (a, b) {
            return (a.flightDate + "-" + a.depTime + "-" + a.flightNo + "-" + a.depAirport + "-" + a.arrAirport ===
                b.flightDate + "-" + b.depTime + "-" + b.flightNo + "-" + b.depAirport + "-" + b.arrAirport);
        }),
    };
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/getNewOldFlights.js
// module id = null
// module chunks = 